import React from 'react';
import {createRoot} from 'react-dom/client';
import './index.css';
import EvidenceBarometer from './EvidenceBarometer';
import reportWebVitals from './reportWebVitals';

// Find all widget divs
const evComponents = document.querySelectorAll('.evidence-barometer');

// Inject our React App into each class
evComponents.forEach(div => {
  if (div instanceof HTMLElement) {
    const articleId = (div.dataset.id || '').toLowerCase();

    // Make sure we have a valid UUID as input.
    if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(articleId)){
      console.warn(`Invalid format "${articleId}" is not a UUID.`);
      console.warn('Evidence Barometer requires a valid *dataset-id* to be set');
      return;
    }

    const root = createRoot(div);
    root.render(
      <React.StrictMode>
        <EvidenceBarometer articleId={articleId} />
      </React.StrictMode>
    );
  }
});

reportWebVitals();